import React from 'react';

export const CurrentDateContext = React.createContext<Date | null>(null);

// This hook is intended to help with issues of dates changing in UI testing
// tools like storybook. Anywhere that the current date is required and will
// be rendered in the UI, you should use this hook so the current date can be
// manually overridden
export const useCurrentDate = () => {
  const context = React.useContext(CurrentDateContext);

  if (context === null) {
    return new Date();
  }

  return context;
};
